import { React } from "react";
import { Doughnut } from "react-chartjs-2";
import Chart from "chart.js/auto"; // eslint-disable-line no-unused-vars
import { DoughnutWrapper } from "./Card.styled";
import PropTypes from "prop-types";

function DoughnutChart({ data, options, totalAmount }) {
	// console.log(totalAmount);
	return (
		<DoughnutWrapper>
			<div className='text'>
				<p className='amount'>{totalAmount}</p>
				<p className='percentile'>{totalAmount < 1 ? "0%" : "100%"}</p>
			</div>

			<Doughnut data={data} options={options}></Doughnut>
		</DoughnutWrapper>
	);
}

DoughnutChart.propTypes = {
	data: PropTypes.object,
	textCenter: PropTypes.object,
	totalAmount: PropTypes.number,
	options: PropTypes.object,
};

export default DoughnutChart;
